import styled from 'styled-components'
import { colors } from 'themes'

export const Wrapper = styled.div<{ isRiskTemplate: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100% !important;

  > label {
    font-size: ${({ isRiskTemplate }) => (isRiskTemplate ? 16 : 12)}px;
    margin-bottom: ${({ isRiskTemplate }) => (isRiskTemplate ? 0 : 6)}px !important;
  }
`

export const GroupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 50%;
`

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  border-radius: 4px;
  background-color: ${colors.gray190};
`

export const GroupHeader = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
`

export const RecordLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  color: ${colors.blue300};

  &:hover {
    text-decoration: underline;
  }
`

export const Postfix = styled.span`
  color: gray;
`

export const FieldsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;

  > div {
    width: 100%;
  }
`
